import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    "data-testid": "modal-title",
    class: "text-xl font-semibold text-gray-900 dark:text-white"
};
const _hoisted_2 = {
    key: 0,
    class: "flex items-center justify-center py-8"
};
const _hoisted_3 = {
    key: 1,
    class: "flex flex-col items-center justify-center py-8 text-center"
};
const _hoisted_4 = { class: "text-lg font-semibold text-gray-900 dark:text-white mb-2" };
const _hoisted_5 = { class: "text-sm text-gray-500 dark:text-gray-400" };
const _hoisted_6 = {
    key: 2,
    class: "space-y-4"
};
const _hoisted_7 = { class: "flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-800 rounded-lg" };
const _hoisted_8 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" };
const _hoisted_9 = { class: "text-sm font-mono text-gray-900 dark:text-white mt-1" };
const _hoisted_10 = ["title"];
const _hoisted_11 = {
    key: 0,
    class: "w-4 h-4 mr-1.5",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
};
const _hoisted_12 = {
    key: 1,
    class: "w-4 h-4 mr-1.5 text-green-600",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
};
const _hoisted_13 = { class: "grid grid-cols-2 gap-4" };
const _hoisted_14 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" };
const _hoisted_15 = { class: "text-sm text-gray-900 dark:text-white mt-1" };
const _hoisted_16 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" };
const _hoisted_17 = { class: "mt-1" };
const _hoisted_18 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" };
const _hoisted_19 = { class: "text-sm text-gray-900 dark:text-white mt-1" };
const _hoisted_20 = {
    key: 0,
    class: "border-t border-gray-200 dark:border-gray-600 pt-4"
};
const _hoisted_21 = { class: "text-sm font-semibold text-gray-900 dark:text-white mb-3" };
const _hoisted_22 = { class: "grid grid-cols-3 gap-4" };
const _hoisted_23 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" };
const _hoisted_24 = { class: "text-sm text-gray-900 dark:text-white mt-1" };
const _hoisted_25 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" };
const _hoisted_26 = { class: "text-sm text-gray-900 dark:text-white mt-1" };
const _hoisted_27 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" };
const _hoisted_28 = { class: "text-sm font-semibold text-gray-900 dark:text-white mt-1" };
const _hoisted_29 = { class: "border-t border-gray-200 dark:border-gray-600 pt-4" };
const _hoisted_30 = { class: "text-sm font-semibold text-gray-900 dark:text-white mb-3" };
const _hoisted_31 = { class: "grid grid-cols-3 gap-4" };
const _hoisted_32 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" };
const _hoisted_33 = { class: "text-sm text-gray-900 dark:text-white mt-1" };
const _hoisted_34 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" };
const _hoisted_35 = { class: "text-sm text-gray-900 dark:text-white mt-1" };
const _hoisted_36 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" };
const _hoisted_37 = { class: "text-sm font-semibold text-gray-900 dark:text-white mt-1" };
const _hoisted_38 = { class: "border-t border-gray-200 dark:border-gray-600 pt-4" };
const _hoisted_39 = { class: "grid grid-cols-2 gap-4" };
const _hoisted_40 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" };
const _hoisted_41 = { class: "text-sm text-gray-900 dark:text-white mt-1" };
const _hoisted_42 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" };
const _hoisted_43 = { class: "text-sm text-gray-900 dark:text-white mt-1" };
const _hoisted_44 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" };
const _hoisted_45 = { class: "text-sm text-gray-900 dark:text-white mt-1" };
const _hoisted_46 = { key: 0 };
const _hoisted_47 = { key: 1 };
const _hoisted_48 = { key: 0 };
const _hoisted_49 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" };
const _hoisted_50 = { class: "text-sm text-gray-900 dark:text-white mt-1" };
import { ref, computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useSubscriptionUtils } from "@/shared/composables/useSubscriptionUtils";
import { Modal, Button, Badge } from "@eudonet/opal";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubscriptionDetailModal',
    props: {
        isOpen: { type: Boolean },
        subscription: {},
        isLoading: { type: Boolean, default: false }
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t } = useI18n();
        const { renderFrequency, formatCurrency, formatDate, formatTransactionDay, getStatusConfig, getOpalBadgeTheme, shouldShowNextTransactionDate, } = useSubscriptionUtils();
        const copied = ref(false);
        const isModalOpen = computed({
            get: () => props.isOpen,
            set: () => handleClose(),
        });
        // Reset copied state when modal opens/closes
        watch(() => props.isOpen, (isOpen) => {
            if (isOpen) {
                copied.value = false;
            }
        });
        function handleClose() {
            if (!props.isLoading) {
                emit("close");
            }
        }
        async function copyToClipboard(text) {
            try {
                await navigator.clipboard.writeText(text);
                copied.value = true;
                setTimeout(() => {
                    copied.value = false;
                }, 2000);
            }
            catch (error) {
                console.warn("Failed to copy to clipboard:", error);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                modelValue: isModalOpen.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((isModalOpen).value = $event)),
                size: "md",
                "data-testid": "subscription-detail-modal",
                dismissable: !__props.isLoading,
                "close-on-escape": !__props.isLoading,
                onClose: handleClose
            }, {
                header: _withCtx(() => [
                    _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.title")), 1 /* TEXT */)
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                        variant: "secondary",
                        label: _unref(t)('dashboard.subscriptions.detail.close'),
                        disabled: __props.isLoading,
                        "data-testid": "close-detail-modal-btn",
                        onClick: handleClose
                    }, null, 8 /* PROPS */, ["label", "disabled"])
                ]),
                default: _withCtx(() => [
                    (__props.isLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[2] || (_cache[2] = [
                                _createElementVNode("div", { role: "status" }, [
                                    _createElementVNode("svg", {
                                        "aria-hidden": "true",
                                        class: "w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600",
                                        viewBox: "0 0 100 101",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg"
                                    }, [
                                        _createElementVNode("path", {
                                            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                                            fill: "currentColor"
                                        }),
                                        _createElementVNode("path", {
                                            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                                            fill: "currentFill"
                                        })
                                    ]),
                                    _createElementVNode("span", { class: "sr-only" }, "Loading...")
                                ], -1 /* CACHED */)
                            ]))]))
                        : (!__props.subscription)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _cache[3] || (_cache[3] = _createElementVNode("svg", {
                                    class: "w-16 h-16 text-gray-400 mb-4",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "aria-hidden": "true"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    })
                                ], -1 /* CACHED */)),
                                _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.notFound")), 1 /* TEXT */),
                                _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.notFoundMessage")), 1 /* TEXT */)
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("dt", _hoisted_8, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.ruleId")), 1 /* TEXT */),
                                        _createElementVNode("dd", _hoisted_9, _toDisplayString(__props.subscription.id), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "inline-flex items-center px-3 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600",
                                        title: _unref(t)('dashboard.subscriptions.detail.copyToClipboard'),
                                        onClick: _cache[0] || (_cache[0] = ($event) => (copyToClipboard(__props.subscription.id)))
                                    }, [
                                        (!copied.value)
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[4] || (_cache[4] = [
                                                    _createElementVNode("path", {
                                                        "stroke-linecap": "round",
                                                        "stroke-linejoin": "round",
                                                        "stroke-width": "2",
                                                        d: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                                                    }, null, -1 /* CACHED */)
                                                ]))]))
                                            : (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[5] || (_cache[5] = [
                                                    _createElementVNode("path", {
                                                        "stroke-linecap": "round",
                                                        "stroke-linejoin": "round",
                                                        "stroke-width": "2",
                                                        d: "M5 13l4 4L19 7"
                                                    }, null, -1 /* CACHED */)
                                                ]))])),
                                        _createTextVNode(" " + _toDisplayString(copied.value
                                            ? _unref(t)("dashboard.subscriptions.detail.copied")
                                            : _unref(t)("dashboard.subscriptions.detail.copyToClipboard")), 1 /* TEXT */)
                                    ], 8 /* PROPS */, _hoisted_10)
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("dt", _hoisted_14, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.shopperReference")), 1 /* TEXT */),
                                        _createElementVNode("dd", _hoisted_15, _toDisplayString(__props.subscription.shopperReference), 1 /* TEXT */)
                                    ]),
                                    _createElementVNode("div", null, [
                                        _createElementVNode("dt", _hoisted_16, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.status")), 1 /* TEXT */),
                                        _createElementVNode("dd", _hoisted_17, [
                                            _createVNode(_unref(Badge), {
                                                label: _unref(t)(_unref(getStatusConfig)(__props.subscription.status).textKey),
                                                theme: _unref(getOpalBadgeTheme)(__props.subscription.status),
                                                size: "sm",
                                                "text-only": ""
                                            }, null, 8 /* PROPS */, ["label", "theme"])
                                        ])
                                    ]),
                                    _createElementVNode("div", null, [
                                        _createElementVNode("dt", _hoisted_18, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.merchantReference")), 1 /* TEXT */),
                                        _createElementVNode("dd", _hoisted_19, _toDisplayString(__props.subscription.merchantReference || "-"), 1 /* TEXT */)
                                    ])
                                ]),
                                (__props.subscription.firstAmount !== null || __props.subscription.firstTaxAmount !== null)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                        _createElementVNode("h4", _hoisted_21, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.firstAmount")), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_22, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("dt", _hoisted_23, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.firstAmount")), 1 /* TEXT */),
                                                _createElementVNode("dd", _hoisted_24, _toDisplayString(_unref(formatCurrency)(__props.subscription.firstAmount ?? 0, __props.subscription.currency)), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", null, [
                                                _createElementVNode("dt", _hoisted_25, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.firstTaxAmount")), 1 /* TEXT */),
                                                _createElementVNode("dd", _hoisted_26, _toDisplayString(_unref(formatCurrency)(__props.subscription.firstTaxAmount ?? 0, __props.subscription.currency)), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", null, [
                                                _createElementVNode("dt", _hoisted_27, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.firstTotalAmount")), 1 /* TEXT */),
                                                _createElementVNode("dd", _hoisted_28, _toDisplayString(_unref(formatCurrency)(__props.subscription.firstTotalAmount ?? 0, __props.subscription.currency)), 1 /* TEXT */)
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("v-if", true),
                                _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("h4", _hoisted_30, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.amount")), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_31, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("dt", _hoisted_32, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.amount")), 1 /* TEXT */),
                                            _createElementVNode("dd", _hoisted_33, _toDisplayString(_unref(formatCurrency)(__props.subscription.amount, __props.subscription.currency)), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("dt", _hoisted_34, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.taxAmount")), 1 /* TEXT */),
                                            _createElementVNode("dd", _hoisted_35, _toDisplayString(_unref(formatCurrency)(__props.subscription.taxAmount, __props.subscription.currency)), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("dt", _hoisted_36, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.totalAmount")), 1 /* TEXT */),
                                            _createElementVNode("dd", _hoisted_37, _toDisplayString(_unref(formatCurrency)(__props.subscription.totalAmount, __props.subscription.currency)), 1 /* TEXT */)
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_38, [
                                    _createElementVNode("div", _hoisted_39, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("dt", _hoisted_40, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.frequency")), 1 /* TEXT */),
                                            _createElementVNode("dd", _hoisted_41, _toDisplayString(_unref(renderFrequency)(__props.subscription.frequency)), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("dt", _hoisted_42, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.transactionDay")), 1 /* TEXT */),
                                            _createElementVNode("dd", _hoisted_43, _toDisplayString(_unref(formatTransactionDay)(__props.subscription.transactionDay)), 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("dt", _hoisted_44, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.transactionCount")), 1 /* TEXT */),
                                            _createElementVNode("dd", _hoisted_45, [
                                                (__props.subscription.transactionCount === null || __props.subscription.transactionCount === 0)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.transactionCountUnlimited")), 1 /* TEXT */))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(__props.subscription.transactionsCompleted ?? 0) + " / " + _toDisplayString(__props.subscription.transactionCount), 1 /* TEXT */))
                                            ])
                                        ]),
                                        (_unref(shouldShowNextTransactionDate)(__props.subscription.status))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                _createElementVNode("dt", _hoisted_49, _toDisplayString(_unref(t)("dashboard.subscriptions.detail.nextTransactionDate")), 1 /* TEXT */),
                                                _createElementVNode("dd", _hoisted_50, _toDisplayString(_unref(formatDate)(__props.subscription.nextTransactionDate)), 1 /* TEXT */)
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ])
                            ]))
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue", "dismissable", "close-on-escape"]));
        };
    }
});
